import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AUTH_PATHS } from '../router/routes'
import { isLoggedIn } from '../../services/authService'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation()

  if (!isLoggedIn()) {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`${AUTH_PATHS.login}?redirect=${redirect}`} replace />
  }

  return <>{children}</>
}
